import { identity } from '../utils/helper';
/**
 * Connector transfom by function.
 */
export var Custom = function Custom(options) {
  var _options$callback = options.callback,
    callback = _options$callback === void 0 ? identity : _options$callback;
  return function (data) {
    return callback(data);
  };
};
Custom.props = {};